import type { QueryClient } from "@tanstack/react-query";

export function invalidateWaitingReplyQueries(client: QueryClient, memberId: number, chatId: number) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ["/api/app/inbox/waiting-reply/messages"] }),
    client.invalidateQueries({ queryKey: ["/api/app/inbox/waiting-reply"] }),
    client.invalidateQueries({ queryKey: ["/api/app/members", memberId, "timeline"] }),
    client.invalidateQueries({ queryKey: ["/api/app/member-chats", chatId, "workflow"] }),
  ]);
}
